/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Yash's Portfolio",
  description:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Yash Rao Portfolio",
    type: "website",
    url: "http://YashKumarRao.com/",
  },
};

//Home Page
const greeting = {
  title: "A.Yash Kumar Rao",
  logo_name: "A.Yash Kumar Rao",
  nickname: "",
  subTitle:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  resumeLink:
    "https://drive.google.com/file/d/11luUTXq7X0bd09oLT379yiKicP6hCkaw/view?usp=sharing",
  portfolio_repository: "https://github.com/ayashkumarrao",
  githubProfile: "https://github.com/ayashkumarrao",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ayashkumarrao",
  // linkedin: "https://www.linkedin.com/in/yashkumarrao/",
  // gmail: "a.yashkumarrao@gmail.com",
  // facebook: "https://www.facebook.com/yash.rao.1042/",
  // twitter: "https://twitter.com/ykr_4798",
  // instagram: "https://www.instagram.com/yash._.rao/"

  {
    name: "Github",
    link: "https://github.com/ayashkumarrao",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/yashkumarrao/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:a.yashkumarrao@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/ykr_4798",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/yash.rao.1042/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/yash._.rao/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Data Analytics & Reporting",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developed and implemented reporting, analytics, and Data visualization solutions with Power BI.",
        "⚡ Experience of working with Tools like Power Bi, DAX, SQL, Tableau & Excel.",
        "⚡ Designing new Dashboard with some innovative layouts.",
      ],
      softwareSkills: [
        {
          skillName: "Excel",
          fontAwesomeClassname: "ri:file-excel-2-fill",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "SQL",
          fontAwesomeClassname: "logos:mysql",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Power Bi",
          fontAwesomeClassname: "logos:microsoft-power-bi",
          style: {
            backgroundColor: "transparent",
            
          },
        },
        {
          skillName: "Tableau",
          fontAwesomeClassname: "logos:tableau-icon",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
   
  ],
};

const degrees = {
  degrees: [
    {
      title: "Sir M Visveswaraya Institute of Technology, Bengaluru",
      subtitle: "B.Tech. in Mechanical Engineering",
      logo_path: "mvit-img.png",
      alt_name: "MVIT Bengaluru",
      duration: "2015-2019",
      descriptions: [
        "⚡ I have studied basic mechanical engineering subjects like Thermodynamics, Mechanics of materials, Kinematics, etc.",
        "⚡ Apart from this, I have done courses on 3d Designing, Darfting, Data Analytics, and Data Visualization, etc.",
        "⚡ I was a part of Team Inferno which  looks to pioneer research and build cars which deliver super-mileages which eventually go on to participate at the annually held Shell Eco Marathon.",
        "⚡ I was into Sports and have received awards for best performance in Sports.",
      ],
      website_link: "https://www.sirmvit.edu/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "SQL",
      subtitle: "- Emma Saunders",
      logo_path: "linkedin.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/37d9092f59a82d19628eace20b965fde4a674f9b94bdd1c7fa8ab9adb54c528a?trk=share_certificate",
      alt_name: "LinkedIn learning",
      color_code: "#8C151599",
    },
    {
      title: "Tableau Analyst",
      subtitle: "- Tableau",
      logo_path: "Tableau.png",
      certificate_link:
        "https://www.credly.com/badges/6d771901-2991-49dd-8339-1bdb288d3e2e/linked_in_profile",
      alt_name: "Tableau",
      color_code: "#00000099",
    },
    {
      title: "Power Bi",
      subtitle: "- Gini von Courter",
      logo_path: "Power Bi.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/de932996ac5df3bfcb9414cc930e48aad4873f5cfe181a25b7ffdb1bbd7d06ea?trk=share_certificate",
      alt_name: "LinkedIn learning",
      color_code: "#0C9D5899",
    },
    {
      title: "Data Science",
      subtitle: "- BoardInfinity",
      logo_path: "BI.png",
      certificate_link:
        "https://drive.google.com/file/d/1BcK7SWPpYvs8gyzYh51JamRltgtLd1kt/view?usp=sharing",
      alt_name: "BoardInfinity",
      color_code: "#2A73CC",
    },
    {
      title: "Python",
      subtitle: "- IBM",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.credly.com/badges/5eadadc6-4642-4193-a9d1-46ceb807b0b4?source=linked_in_profile",
      alt_name: "IBM",
      color_code: "#D83B0199",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work and Internship",
  description:
    "I am currently working with Wells Fargo as Control Management Associate. I have also worked with some other companies mostly in Risk Domain using Excel, VBA, Power BI. I am always keen to learn new skills..",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Control Management Associate",
          company: "Wells Fargo ",
          company_url: "https://www.wellsfargo.com/",
          logo_path: "WF.png",
          duration: "Feb 2021 - PRESENT",
          location: "Hyderabad, Telangana",
          description:
            "I am Working on Power BI (Power Query, Power BI Desktop) and DAX. The activities involve automation for process improvements and for significantly enhancing the Existing Reports. Design and Implementing reporting solutions & implementing Automation using Reporting Services, VBA, & Power BI.",
          color: "#fc1f20",
        },
        {
          title: "Risk Analyst",
          company: "Wipro Ltd.",
          company_url: "https://www.wipro.com/",
          logo_path: "Wipro.jpg",
          duration: "Dec 2020 - Feb 2022",
          location: "Hyderabad, Telangana",
          description:
            "Identified potential financial risks, evaluated clients, and recommendations to executives. Trained and coordinated new analysts, ensuring that all policies and procedures were fully followed and the company's high standards were always met. Collaborated with colleagues on the development of new risk models, performed professional risk assessments, and stayed up to date with current laws and regulations.",
          color: "#0879bf",
        },
        {
          title: "Process Design Engg.",
          company: "Avineon India Pvt. Ltd.",
          company_url: "https://www.avineon.com/en/home",
          logo_path: "Avineon.jpg",
          duration: "Sept 2019 - Aug 2020",
          location: "Hyderabad, Telangana",
          description:
            "As a process designer, I had an opportunity to work closely with the experts of the company to learn various work of the company. Reviewing PFD and P&IDs development, P&ID updating for (Process, Piping & Instrumentation), Creating Intelligent PFD & P&IDs using smart plant P&ID, Generating the plant reports which include Line List, Equipment List & Nozzle List.",
          color: "#219ebc",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Data Analytics - Virtual Internship",
          company: "KPMG",
          company_url: "https://home.kpmg/xx/en/home.html",
          logo_path: "KPMG-Logo.png",
          duration: "May 2019 - Sept 2019",
          location: "Gurgaon, Haryana",
          description:
            " This program gave me a lot of insights on approaching certain problems set in the real world. I got the opportunity to work on three phases, 1. Data Quality Assessment/Data preparation: Assessment of data quality and completeness in preparation of data, right from scratch.2. Data Exploration & Model Development: Targeting high-value customers based on customer demographics and attributes, introducing few calculated fields to solve the problem statement.3. Data Visualization: Using a simple interactive dashboard in Tableau, to present the insights.",
          color: "#0071C5",
        },
      ],
    },
    {
      title: "Achievement",
      experiences: [
        {
          title: "Manager Spot Light Award",
          company: "Wells Fargo",
          // company_url: "https://home.kpmg/xx/en/home.html",
          logo_path: "WF.png",
          // duration: "May 2019 - Sept 2019",
          // location: "Gurgaon, Haryana",
          description:
            "For Outstanding efforts and achievements for Q2",
          color: "#fc1f20",
        },
        {
          title: "Team Spotlight Award",
          company: "Wells Fargo",
          // company_url: "https://home.kpmg/xx/en/home.html",
          logo_path: "WF.png",
          // duration: "May 2019 - Sept 2019",
          // location: "Gurgaon, Haryana",
          description:
            "For Outstanding efforts and achievements : Works Collaboratively",
          color: "#fc1f20",
        },
        {
          title: "Sports Award",
          company: "Sir M Visvesvaraya Institute Of Technology",
          // company_url: "https://home.kpmg/xx/en/home.html",
          logo_path: "mvit-img.png",
          // duration: "May 2019 - Sept 2019",
          // location: "Gurgaon, Haryana",
         description: [
            "⚡ 1st Place in Inter Club Football Event Organized by NGO ABHIKALPANA.",
            "⚡ 2nd Place in Annual Athletic Meet for 100msprint.",
            "⚡ 1st Place in Annual Athletic Meet for 4*100m relay.",
            "⚡ 2nd Place in Inter House Basketball Competition in School Level.",
          ],
          color: "#0071C5",
        },
      ],
    }
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and Data Visualization Dashboard using tools like Power BI & Tableau.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Data Visualization Projects",
  description:
    "I have worked on multiple Storytelling dashboard & Analytical Dashboards.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "yash rao.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with Power BI, DAX, Data Visualization, Data Analytics & Excel Automation.",
  },
  //  blogSection: {
  //    title: "Blogs",
  //    subtitle:
  //      "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
  //    link: "https://ashutoshhathidara.wordpress.com",
  //    avatar_image_path: "blogs_image.svg",
  //  },
  addressSection: {
    title: "Address",
    subtitle:
      "House no. - 1-202, Flat no. - 3, Bhavani nagar, Malkajgiri, Hyderabad - 500047",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/J4KqbSj7HhFpDD1TA",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+91 9893191192",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  contactPageData,
};
